export default __webpack_public_path__ + "static/media/Legguards of Writhing.1c42b381.jpg";